import React from 'react';

const RaisedCard = ({ children }) => (
  <div className="shadow bg-white raised-card">{children}</div>
);

export default RaisedCard;
